import React, { useContext } from 'react'
import MainNavigation from './MainNavigation'
import styles from '../../styles/Layout.module.css'
import { AuthContext } from '../../store/auth-context'
import { Outlet } from 'react-router-dom'


const Layout = (props: any) => {

    const authCtx = useContext(AuthContext)

    return (
        <>
            
            { authCtx.isLoggedIn && <MainNavigation showMenus={props.showMenus} /> }
            <main className={`${styles.mainContainer}`}>
                <Outlet />
            </main>
        </>
    )
}

export default Layout
